var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-180 40 40)",
    fill: "#0099FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 17.4918L19.4833 20.4002C19.6305 20.5164 19.8125 20.5797 20 20.5797C20.1875 20.5797 20.3695 20.5164 20.5167 20.4002L24.1667 17.4918M26.6667 25.8252H13.3333C13.1123 25.8252 12.9004 25.7374 12.7441 25.5811C12.5878 25.4248 12.5 25.2129 12.5 24.9918V14.9918C12.5 14.7708 12.5878 14.5589 12.7441 14.4026C12.9004 14.2463 13.1123 14.1585 13.3333 14.1585H26.6667C26.8877 14.1585 27.0996 14.2463 27.2559 14.4026C27.4122 14.5589 27.5 14.7708 27.5 14.9918V24.9918C27.5 25.2129 27.4122 25.4248 27.2559 25.5811C27.0996 25.7374 26.8877 25.8252 26.6667 25.8252Z",
    stroke: "#EDF1F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.276e43086b7f6062c7a99d48d9b8f94d.svg";
export { ForwardRef as ReactComponent };